// extracted by mini-css-extract-plugin
export default {"mask":"U9MowLv_","main":"RcG6eRZw","foldersSidebarVisible":"oHY8tVQC","foldersSidebar":"HjZ2pMig","left":"oL7XcRwI","middle":"LYe7IaQO","right":"wYSGQZXX","blank":"kN2M6u9m"};